// extracted by mini-css-extract-plugin
export default {"groupTitle":"GroupTitle_groupTitle__3eTOE"};